import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import ItemTypes from './itemTypes';
import { DragSource, DropTarget } from 'react-dnd';

const style = {
    cursor: 'move'
};

const cardSource = {
    beginDrag(props) {
        return {
            id: props.id,
            index: props.index
        };
    },
    endDrag(props, monitor) {
        const item = monitor.getItem();
        const dropResult = monitor.getDropResult();
        if(dropResult) {
            props.dropCard(item.index);
        }
    }
};

const cardTarget = {
    drop(props, monitor) {
        return monitor.getItem();
    },
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        // Time to actually perform the action
        props.moveCard(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    }
};


@DropTarget(ItemTypes.CARD, cardTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    didDrop: monitor.didDrop()
}))
@DragSource(ItemTypes.CARD, cardSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
}))
export default class SentenceRow extends Component {
    static propTypes = {
        connectDragSource: PropTypes.func.isRequired,
        connectDropTarget: PropTypes.func.isRequired,
        connectDragPreview: PropTypes.func.isRequired,
        index: PropTypes.number.isRequired,
        isDragging: PropTypes.bool.isRequired,
        id: PropTypes.any.isRequired,
        position: PropTypes.number.isRequired,
        phrase: PropTypes.string.isRequired,
        study_type: PropTypes.number.isRequired,
        flang: PropTypes.any.isRequired,
        // text: PropTypes.string.isRequired,
        moveCard: PropTypes.func.isRequired,
        dropCard: PropTypes.func.isRequired,
        editSentence: PropTypes.func.isRequired,
        translations: PropTypes.any.isRequired,
        renderIcon: PropTypes.func.isRequired
    };
    render() {
        const { isDragging, connectDragSource, connectDragPreview, connectDropTarget, editSentence,
            id, position, phrase, study_type, flang, delWordOpenModal, translations, addSentence,
            renderIcon, live_situation_type, notification, sentence_number_notification
        } = this.props;
        const opacity = isDragging ? 0.5 : 1;
        return connectDragPreview(connectDropTarget(
            <div style={{ opacity }}>
                <div className="white-block common-list four clearfix draggable">
                    <p>{position}</p>

                    <span className="label_class">{this.props.labelFunction(live_situation_type, notification, sentence_number_notification)}</span>

                    <p className="common-item-with-tag">
                        <span onClick={editSentence.bind(this, id)}>{phrase}</span>
                        {renderIcon(translations)}
                    </p>
                    <p>
                        {study_type == '1' ?
                            <span>Memorise</span>
                            : ""}
                        {study_type == '2' ?
                            <span>Writing</span>
                            : ""}
                        {study_type == '3' ?
                            <span>Speaking</span>
                            : ""}
                    </p>
                    <p>
                        <button type="button" onClick={editSentence.bind(this, id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true"></span>
                        </button>
                        <button type="button" onClick={delWordOpenModal.bind(this, id, flang)}>
                            <span className="span glyphicon glyphicon-trash"></span>
                        </button>
                    </p>
                    <span className="moved_Right_Add glyphicon glyphicon-plus" onClick={addSentence.bind(this, position)} title="Add before sentence"></span>
                    {connectDragSource(
                        <div>
                            <span style={{ ...style }} className="moved_Left glyphicon glyphicon-option-vertical"></span>
                            <span style={{ ...style }} className="moved_Right glyphicon glyphicon-move"></span>
                        </div>
                    )}
                </div>
            </div>
        ));
    }
}



// WEBPACK FOOTER //
// ./src/components/language/sentence_row.js